import Zone from "@insite/client-framework/Components/Zone";
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { isCrossBrandAuthenticated } from "@tSurya/Common/Utilities/brandPermissionUtils";
import BrandAccessDeniedModal from "@tSurya/Components/BrandAccessDeniedModal";
import { useBrandAccessGuard } from "@tSurya/Utils/MyAccountThemeWrapper";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isSignInPage: getCurrentPage(state).type === "SignInPage",
    userName: state.context.session.userName,
    currentUserIsGuest: getCurrentUserIsGuest(state),
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    currentLocation: getLocation(state),
    userRole: state.context.session.userRoles,
    location: state.data.pages.location.pathname,
    sessionProperties: state.context.session.properties,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory;

const SignInRequired = ({
    id,
    userName,
    currentUserIsGuest,
    isSignInPage,
    signInUrl,
    currentLocation,
    history,
    userRole,
    location,
    sessionProperties,
}: Props) => {
    const brandAccessGuardActive = useBrandAccessGuard();
    const isBrandAccessDenied = (!userName || currentUserIsGuest) && isCrossBrandAuthenticated(sessionProperties);

    React.useEffect(() => {
        if (isBrandAccessDenied) {
            return;
        }
        if ((!userName || currentUserIsGuest) && !isSignInPage) {
            if (!signInUrl) {
                logger.warn("No url was found for SignInPage, defaulting to /SignIn");
                history.push("/SignIn");
            }
            else {
                const returnUrl = currentLocation.pathname + currentLocation.search;
                if (returnUrl === "/") {
                    history.push(`${signInUrl}`);
                } else {
                    history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
                }
            }
        }
        if (userRole === "Collaborator" && !location.toLowerCase().includes("freightestimator")) {
            history.push("/")
        }
    }, [isBrandAccessDenied, userName, currentUserIsGuest, isSignInPage, signInUrl, currentLocation, userRole, location]);

    if (isBrandAccessDenied && !brandAccessGuardActive) {
        return (
            <Page>
                <BrandAccessDeniedModal isOpen={true} closeable={false} />
            </Page>
        );
    }

    if (isBrandAccessDenied && brandAccessGuardActive) {
        return null;
    }

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(withHistory(SignInRequired)),
    definition: {
        group: "Basic",
        icon: "LogIn",
        displayName: "Sur Sign In Required",
    },
};
export default widgetModule;
